/*jshint esversion:6  */
import React from "react";
import Toaster from "toastr";
import Datepicker from "react-datepicker";
import ArbiterApi from "../../../api/ArbiterApi";
import { Permissioned } from "react-permissions";
import { connect } from "react-redux";
import Constants from "../../../configurations/constants";
import Permissions from "../../../configurations/permissions";
import Messages from "../../../configurations/messages";
import Util from "../../../util/util";
import SelectDropdown from "../disputes/DisputeSelectDropdown";

class BulkUpdateStatusFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      transactionGroups: [],
      transactionGroup: null,
      createdFromDate: null,
      createdToDate: null,
      expiresFromDate: null,
      expiresToDate: null,
      transactionFromDate: null,
      transactionToDate: null,
      dateFilterChecked: true,
      searchButtonDisabled: true,
      params: {}
    };

    
    this.onCreatedFromDateChange = this.onCreatedFromDateChange.bind(this);
    this.onCreatedToDateChange = this.onCreatedToDateChange.bind(this);
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
  }

  sortArrayOfObjects = arr => {
    if(arr && arr.length) {
      let newArr;
      newArr = arr.sort(function(a, b){
        if(a.label < b.label) { return -1; }
        if(a.label > b.label) { return 1; }
        return 0;
    })
    return newArr
    }
  }

  getTransactionGroups = (cb) => {
    ArbiterApi.getDisputeCategoriesBulk()
      .then(response => {
        let transactionGroups = response.data.map(obj => {
          obj.label = obj.category;
          obj.value = obj.category;
          return obj;
        });
        if(cb) cb();
        this.setState({ transactionGroups });
      })
      .catch(error => {
        if(cb) cb()
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_DISPUTE_CATEGORIES}`
        ]);
        console.log(error);
      });
  }
  

  onTextInputChange(event) {
    let stateUpdate = {};
    stateUpdate[event.target.id] = event.target.value;
    this.setState(stateUpdate);
  }

  onCreatedFromDateChange(date) {
    this.setState({ createdFromDate: date });
  }
  onCreatedToDateChange(date) {
    this.setState({ createdToDate: date });
  }

  buildParamsForCallback =()=> {
    //TODO: validate control values AND BUILD PARAMS
    //Build Params
    let params = {};
    
    params.category =  this.state.params && this.state.params.category ? this.state.params.category : this.state.transactionGroup;

    params.createdStartDate = this.state.params && this.state.params.createdStartDate ? this.state.params.createdStartDate : this.state.createdFromDate
      .startOf("day")
      .format(`${Constants.DATE_FORMAT_LONG}`);

    params.createdEndDate = this.state.params && this.state.params.createdEndDate ? this.state.params.createdEndDate : this.state.createdToDate
    .startOf("day")
    .format(`${Constants.DATE_FORMAT_LONG}`);

    return params;
  }

  onSearchHandler() {
    let params = {};
    if (this.state.transactionGroup) params.category = this.state.transactionGroup;

    if (this.state.createdFromDate)
      params.createdStartDate = this.state.createdFromDate
        .startOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);

    if (this.state.createdToDate)
      params.createdEndDate = this.state.createdToDate
        .endOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);
   this.setState({ params }, () => {
      this.props.updateParentParams(params)
      this.props.onSearchHandler && this.props.onSearchHandler(params, true);
   })
   
  }

  onTransactionGroupChange = (event) => {
    this.setState({
      transactionGroup: event ? event.value : ""
    });
    
  }

  render() {
    return (
      <form
        onSubmit={e => {
          this.onSearchHandler();
          e.preventDefault();
          return false;
        }}
      >
        <div className="row filters">
        <div className="col-md-10">
            <div className="row"> 
                <div className="col-md-3">
                <div>
                    <label>Dispute Category</label>
                </div>
                <div className="datepicker-container">
                    <SelectDropdown
                      name="transactionGroup"
                      placeholder="Dispute Category"
                      value={this.state.transactionGroup}
                      options={this.state.transactionGroups}
                      // options={sampletg}
                      onChange={this.onTransactionGroupChange}
                      loadOptions={this.getTransactionGroups}
                    />
                </div>
                </div>
                
                <div className="col-md-3">
                <div>
                    <label>Created Start Date</label>
                </div>
                <div className="datepicker-container">
                    <Datepicker
                    onChange={this.onCreatedFromDateChange}
                    className="form-control float_input"
                    id="createdFromDate"
                    placeholderText="Start Date"
                    disabledKeyboardNavigation
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    maxDate={
                        this.state.createdToDate
                        ? this.state.createdToDate
                        : null
                    }
                    dateFormat={Constants.DATE_FORMAT}
                    selected={this.state.createdFromDate}
                    />
                </div>
                </div>
                <div className="col-md-3">
                <div>
                    <label>Created End Date</label>
                </div>
                <div className="datepicker-container">
                    <Datepicker
                    onChange={this.onCreatedToDateChange}
                    className="form-control float_input"
                    id="createdToDate"
                    placeholderText="End Date"
                    disabledKeyboardNavigation
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    minDate={
                        this.state.createdFromDate
                        ? this.state.createdFromDate.clone().add(1, "days")
                        : null
                    }
                    dateFormat={Constants.DATE_FORMAT}
                    selected={this.state.createdToDate}
                    />
                </div>
                </div>
                <div className="col-md-2">
                  <div className="datepicker-container">
                    <button
                        id="searchButton"
                        className="btn btn-primary btn-block"
                        type="submit"
                        disabled={this.props.loading}
                    >
                        {this.props.loading ? "..." : "Search"}
                    </button>
                  </div>
                </div>
            </div>
        </div>
        </div>
      </form>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(BulkUpdateStatusFilter, [Permissions.VIEW_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/bulk_update_status/BulkUpdateStatusFilter.js